/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Digest_Turn_OnInputs */

const en_digest_turn_on = /** @type {(inputs: Digest_Turn_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get the Monday digest`)
};

/**
* | output |
* | --- |
* | "Get the Monday digest" |
*
* @param {Digest_Turn_OnInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const digest_turn_on = /** @type {((inputs?: Digest_Turn_OnInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Digest_Turn_OnInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_digest_turn_on(inputs)
});